import type { NavConfig } from '@/types/nav-config';

export const participantNavConfig: NavConfig = [
    {
        type: 'link',
        labelKey: 'app.navigation.notifications',
        icon: 'fe-bell',
        route: 'notificationsManagementParticipants',
        tourKey: 'notifications',
        badge: { source: 'unreadNotifications', variant: 'danger' },
    },
    {
        type: 'link',
        labelKey: 'app.navigation.dashboard',
        icon: 'fe-grid',
        route: 'dashboard',
        tourKey: 'dashboard',
    },
    {
        type: 'link',
        labelKey: 'app.navigation.myModules',
        icon: 'fe-book-open',
        route: 'courses',
        tourKey: 'modules',
    },
    {
        type: 'link',
        labelKey: 'app.navigation.userReports',
        icon: 'fe-bar-chart-2',
        route: 'skillProgress',
        tourKey: 'reports-and-analytics',
    },
];
